import type { UseFormReturn } from 'react-hook-form'
import type { z } from 'zod'
import { Field } from '../../components/ui/Field'
import { FormCard } from '../../components/ui/FormCard'
import type { customerSchema } from '../../schemas/adminSchemas'

type CustomerFormValues = z.infer<typeof customerSchema>

export function CustomerForm({
  form,
  submitLabel,
  onSubmit,
}: {
  form: UseFormReturn<CustomerFormValues>
  submitLabel: string
  onSubmit: (values: CustomerFormValues) => void | Promise<void>
}) {
  return (
    <FormCard title="Customer Form" submitLabel={submitLabel} onSubmit={form.handleSubmit(onSubmit)}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Field label="Full Name" error={form.formState.errors.name?.message} {...form.register('name')} />
        <Field label="Mobile number" maxLength={10} error={form.formState.errors.mobile?.message} {...form.register('mobile')} />
        <Field label="Email" type="email" error={form.formState.errors.email?.message} {...form.register('email')} />
        <Field as="select" label="Gender" error={form.formState.errors.gender?.message} {...form.register('gender')}>
          <option>Male</option>
          <option>Female</option>
          <option>Other</option>
        </Field>
        <Field as="select" label="Status" error={form.formState.errors.status?.message} {...form.register('status')}>
          <option>Active</option>
          <option>Blocked</option>
        </Field>
      </div>
    </FormCard>
  )
}
